import React, { useState } from "react";
import WhatShapeHeader from "./what-shape-constant/Header";
import WhatShapeSideImage from "./what-shape-constant/SideImage";
import WhatShapeRightPanel from "./what-shape-constant/RightPanel";
import { Icons, Images } from "../assets/assets";

export default function WhatShapeConstant() {
  const items = [
    {
      id: "mission",
      image: Images?.ourMission1,
      number: "01",
      title: "Our Mission",
      content: (
        <p>
          At Konstant, we understand that your brand’s online presence reflects
          your vision, performance, and credibility. With a mission to solidify
          your online presence through thoughtfully{" "}
          <a className="interlink" href="https://www.konstantinfo.com/">
            crafted digital solutions
          </a>
          , our team of skilled developers and designers is committed to
          understand your complex challenges to turn them into workable codes.
          We focus on crafting web and{" "}
          <a
            className="interlink"
            href="https://www.konstantinfo.com/mobile-application-development"
          >
            mobile app solutions
          </a>{" "}
          that enable organizations to operate efficiently and outperform their
          competitors.
        </p>
      ),
      chipRows: [
        [
          { label: "Brand credibility", icon: Icons?.values.beReal },
          { label: "Digital excellence", icon: Icons?.values.beAccountable },
          { label: "Custom solutions", icon: Icons?.values.passionate },
          { label: "Problem solving", icon: Icons?.values.makingDifference },
        ],
        [
          { label: "Scalable systems", icon: Icons?.values.questToLearn },
          {
            label: "Performance driven",
            icon: Icons?.values.collaborativeWorking,
          },
          { label: "Web innovation", icon: Icons?.values.resultsMatter },
          { label: "Mobile efficiency", icon: Icons?.values.alwaysConnected },
        ],
      ],
    },
    {
      id: "vision",
      image: Images?.ourMission3,
      number: "02",
      title: "Our Vision",
      content: (
        <p>
          We vision to help growing startups as well as large-scale enterprises
          improve their operational workflows and performance through{" "}
          <a
            className="interlink"
            href="https://www.konstantinfo.com/enterprise-app-development"
          >
            high-quality enterprise mobility
          </a>{" "}
          and digital solutions driven by modern tech and features. With a
          commitment to be your trusted technology partner, we craft
          quality-backed mobile and web solutions that create, measure impact,
          simplify every process, and streamline digital interactions for your
          users.
        </p>
      ),
      chipRows: [
        [
          { label: "Startup growth", icon: Icons?.values.beReal },
          { label: "Enterprise scale", icon: Icons?.values.beAccountable },
          { label: "Workflow optimization", icon: Icons?.values.passionate },
          { label: "Smart mobility", icon: Icons?.values.makingDifference },
        ],
        [
          { label: "Modern technology", icon: Icons?.values.questToLearn },
          {
            label: "Digital transformation",
            icon: Icons?.values.collaborativeWorking,
          },
          { label: "Trusted partnership", icon: Icons?.values.resultsMatter },
          { label: "Measurable impact", icon: Icons?.values.alwaysConnected },
        ],
      ],
    },
    {
      id: "values",
      image: Images?.ourMission2,
      number: "03",
      title: "Our Values",
      content: (
        <div>
          <p>
            Since 2003, we have been helping businesses to transform their ideas
            into innovative digital solutions. Our work ethics and values define
            how we collaborate and deliver results. We believe in
            accountability, integrity, and a strong commitment to quality in
            everything we do. By prioritizing client success, innovation, and
            teamwork, we help businesses to accelerate their digital
            transformation journey and stay ahead in today’s rapidly evolving
            digital landscape.
          </p>
        </div>
      ),
      chipRows: [
        [
          { label: "Client success", icon: Icons?.values.beReal },
          { label: "Accountability first", icon: Icons?.values.beAccountable },
          { label: "Integrity driven", icon: Icons?.values.passionate },
          { label: "Quality focused", icon: Icons?.values.makingDifference },
        ],
        [
          { label: "Innovation mindset", icon: Icons?.values.questToLearn },
          {
            label: "Team collaboration",
            icon: Icons?.values.collaborativeWorking,
          },
          { label: "Long-term commitment", icon: Icons?.values.resultsMatter },
          { label: "Digital leadership", icon: Icons?.values.alwaysConnected },
        ],
      ],
    },
  ];
  const [openId, setOpenId] = useState<string | null>(items[0]?.id ?? null);
  const selectedImage = items.find((item) => item?.id == openId);
  return (
    <section className="2xl:py-[120px] py-[60px] bg-[#D9E2ED]">
      <div className="max-w-[2500px] mx-auto w-[calc(100%_-_10%)] flex flex-col lg:gap-[70px] gap-[10px]">
        <WhatShapeHeader />
        <div className="flex flex-col 2xl:flex-row justify-between gap-[30px]">
          <WhatShapeSideImage selectedImage={selectedImage?.image} />
          <WhatShapeRightPanel
            items={items}
            openId={openId}
            setOpenId={setOpenId}
          />
        </div>
      </div>
    </section>
  );
}
